<template>
  <div style="height:100%">
    <transition name="maincontent">
      <div class="mainContent" v-show="mainContent">
        <div class="wrapper">
          <header>
            <h1>
              <picture>
                <source media="(max-width:960px)" srcset="/img/logo_title_sp.png"/>
                <img src="/img/logo_title_txt.png" srcset="/img/logo_title_txt@2x.png 2x" alt="～">
              </picture>
            </h1>
          </header>

          <div id="mapArea">
            <div id="mapViewPhotos" class="fade" @click="openModalThumbnailList()">
              <img src="/img/blank.gif" alt="View Photos">
            </div><!-- /mapViewPhotos -->
            <!--
            <div id="mapMenu">
              <div id="menu01" :class="tag == '' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode01" @click="searchWorkByTag('')"></div>
              <div id="menu02" :class="tag == '春' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode02" @click="searchWorkByTag('春')"></div>
              <div id="menu03" :class="tag == '夏' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode03" @click="searchWorkByTag('夏')"></div>
              <div id="menu04" :class="tag == '秋' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode04" @click="searchWorkByTag('秋')"></div>
              <div id="menu05" :class="tag == '冬' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode05" @click="searchWorkByTag('冬')"></div>
            </div>
            -->
            <div id="gMapArea">
              <GmapMap
                :center="center"
                :zoom="zoom"
                :options="options"
                ref="map"
                style="width: 100%; height: 100%; position: absolute;"
              >
                <GmapCluster
                    :gridSize="16"
                    :zoomOnClick="true"
                    :minimumClusterSize="2"
                    :styles="clusterStyles"
                    ref="cluster"
                >
                  <GmapMarker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :position="marker.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="marker.icon"
                    @mouseover="marker.openInfoWindow=true"
                    @mouseout="marker.openInfoWindow=false"
                    @click="openModal(marker.work)"
                  >
                    <GmapInfoWindow
                      :options="{maxWidth: 300, disableAutoPan: true}"
                      :opened="marker.openInfoWindow"
                    >
                      <img :src="marker.imageUrl" style="maxWidth: 200px; margin-left:2px">
                    </GmapInfoWindow>
                  </GmapMarker>
                </GmapCluster>
              </GmapMap>
            </div><!-- /gMapArea -->
          </div><!-- /mapArea-->
        </div><!-- /wrapper -->

        <footer>
          <div class="logos">
            <a target="_blank" rel="noopener noreferrer" href="https://www.city.sagamihara.kanagawa.jp/">
              <picture>
                <source media="(max-width:960px)" srcset="/img/logos_sp.png"/><img src="/img/logos.png" srcset="/img/logos@2x.png 2x" alt="東京カメラ部" />
              </picture>
            </a>
          </div><!-- /logos -->
          <div class="copyrightArea">
            <div class="about">
              <a class="fade" @click="openModalAbout()">
                <picture>
                  <source media="(max-width:960px)" srcset="/img/btn_about_sp.png"/><img src="/img/btn_about.png" srcset="/img/btn_about@2x.png 2x" alt="フォトスポットサイトとは？" />
                </picture>
              </a>
            </div><!-- /about -->
            <div class="copyright">
              <p><picture>
                <source media="(max-width:960px)" srcset="/img/txt_copyright_sp.png"/><img src="/img/txt_copyright.png" alt="Copyright &copy; Tokyo Camera Club Corp. All rights reserved.">
              </picture></p>
            </div><!-- /copyright -->
          </div><!-- /copyrightArea -->
        </footer>

      </div>
    </transition><!-- /#maincontent -->

    <ModalAbout
      :open.sync="modalAbout"
    ></ModalAbout>

    <ModalPhoto
      :open.sync="modalPhoto"
      :work.sync="modalWork"
    ></ModalPhoto>

    <ModalThumbnailList
      :open.sync="modalThumbnailList"
      :works.sync="works"
      :mode.sync="mode"
      :tag.sync="tag"
      @change="changeMode"
      @click="clickThumbnailWork"
      @searchWorkByTag="searchWorkByTag"
    ></ModalThumbnailList>

  </div>
</template>

<script>
import { Me } from '@/api'
import { mapActions, mapGetters } from 'vuex'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import ModalAbout from '@/views/ModalAbout.vue'
import ModalPhoto from '@/views/ModalPhoto.vue'
import ModalThumbnailList from '@/views/ModalThumbnailList.vue'
import enumMixin from '@/concern/enumMixin'

export default {
  mixins: [enumMixin], // Enum値の読み込み
  components: {
    GmapCluster,
    ModalAbout,
    ModalPhoto,
    ModalThumbnailList
  },
  data () {
    return {
      // 作品
      works: [],
      tag: '',
      mode: null,
      // GoogleMap関連
      center: { lat: 43.5880947, lng: 142.4647807 },
      zoom: 10,
      options: {
        clickableIcons: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        styles: [
          { featureType: 'landscape.natural', stylers: [{ color: '#FFFFFF' }] },
          { featureType: 'road', stylers: [{ gamma: 2.61 }, { color: '#e8e8e8' }] },
          { featureType: 'transit.line', stylers: [{ invert_lightness: true }, { visibility: 'simplified' }, { color: '#e8e8e8' }] },
          { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#b7bdc7' }] },
          { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ visibility: 'simplified' }, { color: '#FFFFFF' }] },
          { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#e8e8e8' }] },
          { featureType: 'water', stylers: [{ color: '#b7bdc7' }] },
          { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#e8e8e8' }] }
        ]
      },
      markers: [],
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false
      },
      clusterStyles: [
        { textColor: 'white', url: '/img/googlemap/m1.png', height: 74, width: 72, anchorText: [0, 1] },
        { textColor: 'white', url: '/img/googlemap/m2.png', height: 77, width: 74, anchorText: [0, 1] },
        { textColor: 'white', url: '/img/googlemap/m3.png', height: 87, width: 84, anchorText: [0, 1] },
        { textColor: 'white', url: '/img/googlemap/m4.png', height: 99, width: 96, anchorText: [0, 1] },
        { textColor: 'white', url: '/img/googlemap/m5.png', height: 111, width: 109, anchorText: [0, 1] }
      ],
      // モーダル関連
      modalWork: null,
      modalPhoto: false,
      modalThumbnailList: false,
      modalAbout: false,
      // ビジュアル切り替え用
      mainContent: false
    }
  },
  async created () {
    // APIデータの取得
    await Me.getUserWorks()
      .then(async response => {
        // 国名はいらないので「日本、」という文字列を削除
        for (const work of response.data) work.address = work.address.replace('日本、', '')
        // 変数に格納
        this.initWorks(response.data)
      })
    // モード01を初期状態にセット
    this.mode = this.EnumMode01
    this.works = this.works01
    // 地図の表示
    this.showMap()

    // 初期画面遷移の決定
    if (this.$route.path.includes('/about')) { // aboutが指定されていた場合は開く
      this.openModalAbout()
    } else if (this.$route.path.includes('/list')) { // listが指定されていた場合は開く
      this.openModalThumbnailList()
    } else if (this.$route.params.id) { // 画像が指定されていた場合は開く
      for (const work of this.works01) {
        if (parseInt(work.id) === parseInt(this.$route.params.id)) {
          this.openModal(work)
          break
        }
      }
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'works01', 'works02', 'works03', 'works04', 'works05'
    ]),
    mode01ON () {
      return this.mode === this.EnumMode01 ? 'on' : 'fade'
    },
    mode02ON () {
      return this.mode === this.EnumMode02 ? 'on' : 'fade'
    },
    mode03ON () {
      return this.mode === this.EnumMode03 ? 'on' : 'fade'
    },
    mode04ON () {
      return this.mode === this.EnumMode04 ? 'on' : 'fade'
    },
    mode05ON () {
      return this.mode === this.EnumMode05 ? 'on' : 'fade'
    }
  },
  methods: {
    ...mapActions([
      'updateWorks01', 'updateWorks02', 'updateWorks03', 'updateWorks04', 'updateWorks05'
    ]),
    // マップ表示メソッド
    async showMap () {
      this.mainContent = true
      // マーカーセット
      await this.setMarker(this.works)
      // URLに作品個別のパラメータ（?id=**）があった場合は作品モーダルを開く
      if (this.$route.query.id) {
        let modalWork = null
        for (const work of this.works) if (work.id === Number(this.$route.query.id)) modalWork = work
        if (modalWork) {
          setTimeout(() => {
            this.zoom = 10
            this.openModalByTymbnail(modalWork)
          }, 1500)
        }
      }
    },
    // 作品の初期化メソッド
    initWorks (works) {
      // 緯度順にソート（サムネイルで見た時に何かしら意味のある並びにする）
      works.sort(function (a, b) {
        if (a.latitude > b.latitude) return -1
        else return 1
      })
      // データの振り分け
      const works01 = []
      // const works02 = []
      // const works03 = []
      // const works04 = []
      // const works05 = []

      // 季節ごとに振り分けるパターン
      // for (const work of works) {
      //   works01.push(work) // 01は全作品
      //   const date = new Date(work.takenAt)
      //   const month = date.getMonth() + 1
      //   if ([3, 4, 5].includes(month)) works02.push(work) // 02は春
      //   if ([6, 7, 8].includes(month)) works03.push(work) // 03は夏
      //   if ([9, 10, 11].includes(month)) works04.push(work) // 04は秋
      //   if ([12, 1, 2].includes(month)) works05.push(work) // 05は冬
      // }

      // スポット情報（受賞年度）で分けるパターン
      for (const work of works) {
        works01.push(work) // 01は全作品
        // console.log('work.spotInformations', work.spotInformations)
        // if (work.spotInformations && work.spotInformations.year === '2019') works02.push(work) // 02は2019
        // if (work.spotInformations && work.spotInformations.year === '2020春夏') works03.push(work) // 03は2020春夏
        // if (work.spotInformations && work.spotInformations.year === '2020秋冬') works04.push(work) // 04は2020秋冬
      }

      // 振り分けたデータをvuexのデータにセット
      this.updateWorks01(works01)
      // this.updateWorks02(works02)
      // this.updateWorks03(works03)
      // this.updateWorks04(works04)
      // this.updateWorks05(works05)
    },
    // マーカーセッドメソッド
    async setMarker (works, fit = true) {
      // markerの初期化
      this.markers.splice(0)
      const latitudes = []
      if (!works || works.length === 0) return false
      // マーカーの作成
      for (const work of works) {
        // 緯度が重複していた場合ずらす
        let latitude = parseFloat(work.latitude)
        while (true) {
          if (latitudes.includes(latitude)) latitude = latitude + 0.00001
          else break
        }
        latitudes.push(latitude)
        this.markers.push({
          position: { lat: parseFloat(latitude), lng: parseFloat(work.longitude) },
          work: work,
          openInfoWindow: false,
          imageUrl: work.thumbnailUrl,
          icon: { url: '/img/googlemap/icon_photo_s.png' }
        })
      }
      // 表示領域の自動調整（fit=trueの場合）
      if (fit) {
        // 中心・倍率・表示範囲の計算
        let minX = this.markers[0].position.lng
        let maxX = this.markers[0].position.lng
        let minY = this.markers[0].position.lat
        let maxY = this.markers[0].position.lat
        for (const marker of this.markers) {
          if (marker.work.country !== '日本') continue
          if (marker.position.lng <= minX) { minX = marker.position.lng }
          if (marker.position.lng > maxX) { maxX = marker.position.lng }
          if (marker.position.lat <= minY) { minY = marker.position.lat }
          if (marker.position.lat > maxY) { maxY = marker.position.lat }
        }
        // 領域自動調整
        this.$gmapApiPromiseLazy().then(async () => {
          const sw = new window.google.maps.LatLng(maxY, minX)
          const ne = new window.google.maps.LatLng(minY, maxX)
          const bounds = new window.google.maps.LatLngBounds(sw, ne)
          const map = await this.$refs.map.$mapPromise
          map.fitBounds(bounds)
        })
      }
    },
    // 季節切り替えメソッド
    changeMode (mode) {
      // モードによって作品を切り替え
      this.mode = mode
      if (this.mode === this.EnumMode01) {
        this.works = this.works01
      } else {
        const resultWorks = []
        for (const work of this.works01) {
          const date = new Date(work.takenAt)
          const month = date.getMonth() + 1
          if (this.mode === this.EnumMode02) {
            if ([3, 4, 5].includes(month)) resultWorks.push(work) // 02は春
          } else if (this.mode === this.EnumMode03) {
            if ([6, 7, 8].includes(month)) resultWorks.push(work) // 03は夏
          } else if (this.mode === this.EnumMode04) {
            if ([9, 10, 11].includes(month)) resultWorks.push(work) // 04は秋
          } else if (this.mode === this.EnumMode05) {
            if ([12, 1, 2].includes(month)) resultWorks.push(work) // 05は冬
          }
        }
        this.works = resultWorks
      }
      // マーカーの再設定
      this.setMarker(this.works, false)
    },
    // タグによる検索処理
    searchWorkByTag (tag) {
      this.tag = tag
      if (tag) {
        // 全データから該当データを取得（works01は全データが入っている）
        const resultWorks = []
        for (const work of this.works01) {
          if (work.tags) {
            for (const tagText of work.tags) {
              if (tagText === tag) {
                resultWorks.push(work)
                break
              }
            }
          }
        }
        this.works = resultWorks
      } else {
        this.works = this.works01 // そのまま全データを設定
      }
      // マーカーの再設定
      this.setMarker(this.works)
    },
    // 作品個別モーダルオープン
    openModal (work) {
      this.modalWork = work
      this.modalPhoto = true
      // 個別画像ページへURL書き換え
      const path = `/images/${work.id}`
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = ((work.spotInformations && work.spotInformations.spotname) ?? '') + ' - 相模原市フォトスポットサイト' // タイトル書き換え
    },
    // サムネイル一覧画面からの作品個別モーダルオープン
    openModalByTymbnail (work) {
      this.$gmapApiPromiseLazy().then(async () => {
        const map = await this.$refs.map.$mapPromise
        map.panTo(new window.google.maps.LatLng(work.latitude, work.longitude))
        setTimeout(() => {
          this.modalWork = work
          this.modalPhoto = true
          const path = `/images/${work.id}`
          if (path !== this.$route.path) {
            this.$router.push(path)
          }
          document.title = ((work.spotInformations && work.spotInformations.spotname) ?? '') + ' - 相模原市フォトスポットサイト' // タイトル書き換え
        }, 700)
      })
    },
    // サムネイル一覧画面での作品クリック
    clickThumbnailWork (work) {
      this.zoom = 10
      setTimeout(() => {
        this.openModalByTymbnail(work)
      }, 300)
    },
    // サムネイル一覧オープン
    openModalThumbnailList () {
      this.modalThumbnailList = true
      const path = '/list'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '一覧で作品を見る - 相模原市フォトスポットサイト' // タイトル書き換え
    },
    // アバウトモーダルオープン
    openModalAbout () {
      this.modalAbout = true
      const path = '/about'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '相模原市フォトスポットサイトとは - 相模原市フォトスポットサイト' // タイトル書き換え
    }
  }
}
</script>

<style>
/*--------------------------------------------------------------------
Google Map関連
--------------------------------------------------------------------*/
.vue-map-container {
  height: 100% !important;
  z-index: 0 !important;
}
.gm-ui-hover-effect {
  display: none !important;
}
body::-webkit-scrollbar {
  display: none !important;
  -webkit-appearance: none !important;
}
.vm--container::-webkit-scrollbar {
  display: none !important;
  -webkit-appearance: none !important;
}
.vm--container.scrollable .vm--modal {
  margin-bottom: 0px !important;
}
/*--------------------------------------------------------------------
メインコンテントトランジション
--------------------------------------------------------------------*/
.maincontent-enter-active, .maincontent-leave-actibe {
  transition: opacity 2s;
}
.maincontent-enter, .maincontent-leave-to {
  opacity: 0;
  transition: opacity 1.0s;
}
</style>
